declare global {
	interface Window {
		__env?: {
			stripePublicKey?: string
			auth0Domain?: string
			auth0ClientId?: string
			backendApiUrl?: string
		}
	}
}

export const appEnv = {
	stripePublicKey: window.__env?.stripePublicKey ?? '',
	auth0Domain: window.__env?.auth0Domain ?? '',
	auth0ClientId: window.__env?.auth0ClientId ?? '',
	backendApiUrl: window.__env?.backendApiUrl ?? ''
}
